export default __webpack_public_path__ + "static/tile-anatomy-light-7d6ef2e6967b3ce593537c5f5aaf941b.png";